import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import SvgIcon from '@home/components/SvgIcon';

import './index.scss';

interface IAddShortcutCardProps extends IBaseProps {
  onClick?: () => void;
}

const AddShortcutCard: React.FC<IAddShortcutCardProps> = (props) => {
  const { style, className, onClick } = props;
  const { formatMessage } = useIntl();
  const isClickable = typeof onClick === 'function';

  return (
    <div
      style={style}
      className={classnames(
        'dbh-add-shortcut-card dbh-shortcut-card dbh-url-collection-card-base dbh-url-collection-card-base--add',
        className,
        {
          'dbh-url-collection-card-base--clickable': isClickable,
        },
      )}
      aria-label={formatMessage({
        id: 'dbh_url_collection_add_shortcut',
        defaultMessage: 'Add Shortcut',
      })}
      onClick={onClick}
    >
      <SvgIcon className="dbh-add-shortcut-card__add-icon" type="icon_add_game" />
    </div>
  );
};

export default AddShortcutCard;
